/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */
import React from 'react';
import { useQuery } from '@apollo/client';
import mbpLogger from '@module-logger/mbp';
import {
    string, func, object,
} from 'prop-types';

import withStyles from '@material-ui/core/styles/withStyles';
import findContent from '../../../../gql/queries/findContent';
import CardTemplate from './CardTemplate';
import GraphqlPortalLoader from '../../../../components/GraphqlComponents/GraphqlCommonComponents/GraphqlPortalLoader';

const styles = (theme) => ({
    occasionTitle: {
        margin: '20px 10px',
        fontSize: 16,
        color: theme.palette.cgc?.bgTextOverlay1 || 'rgba(0,0,0,0.6)',
    },
});
const GraphqlGreetingCardsContainer = ({
    brandUid, occasionId, setCardTemplate, title, classes,
}) => {
    let response = null;
    if (!occasionId || !brandUid) {
        response = null;
    }
    const query = `\\"brands\\":{\\"uid\\":\\"${brandUid}\\",\\"_content_type_uid\\":\\"brands\\"},\\"ocassions\\": {\\"uid\\":\\"${occasionId}\\",\\"_content_type_uid\\":\\"ocassions\\"}`;
    const GREETING_CARDS_QUERY = findContent({ brand: 'gci', contentType: 'greeting_cards', query });
    const { data, error, loading } = useQuery(GREETING_CARDS_QUERY);
    if (loading) {
        response = <GraphqlPortalLoader />;
    } else if (error || !data) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            query: GREETING_CARDS_QUERY,
            component: 'GraphqlGreetingCardsContainer.js',
            message: `Failed to fetch content data for: content type brands,query ${query} on brand gci`,
            error,
        });
        response = null;
    } else if (data?.findContent?.content?.entries) {
        const templates = data.findContent.content.entries;
        const dataCheck = templates?.filter((a) => a.sku);
        const titleData = dataCheck?.length > 0 ? <h3 className={classes.occasionTitle}>{title}</h3> : '';
        response = (templates
            && (
                <>
                    {titleData}
                    {(templates || []).map((templateItem) => (templateItem.sku
                        && (
                            <CardTemplate
                                key={templateItem.sku}
                                setCardTemplate={setCardTemplate}
                                template={templateItem}
                            />
                        )
                    ))}
                </>
            )
        );
    }

    return response;
};
GraphqlGreetingCardsContainer.propTypes = {
    classes: object.isRequired,
    brandUid: string.isRequired,
    occasionId: string.isRequired,
    setCardTemplate: func.isRequired,
    title: string.isRequired,
};
export default withStyles(styles)(GraphqlGreetingCardsContainer);
